import { createWidget } from '@alfa-bank/site-util-create-widget/create-widget';
import { PhoneInput } from '@alfa-bank/site-input/phone-input-v2';
import { getPhoneCaption as getCaption } from '@alfa-bank/site-helpers-form/meta/get-caption';
import { isPhoneError as isError } from '@alfa-bank/site-helpers-form/meta/is-error';
import { isSuccess } from '@alfa-bank/site-helpers-form/meta/is-success';
import { Field } from '@alfa-bank/site-form-utils/components/form-field';
// eslint-disable-next-line
import { Phone as Component } from '@alfa-bank/site-form-phone/src/form-phone';

import { validatePhone } from './helpers';
import type { IDeps, TInputPhone } from './models';

export const InputPhone = createWidget<IDeps, TInputPhone>({
    Field,
    PhoneInput,
    isSuccess,
    isError,
    getCaption,
    validatePhone,
})(Component);
